import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import Skeleton from "@material-ui/lab/Skeleton";
import Box from "@material-ui/core/Box";
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles((theme) => ({
    btn: {
        backgroundColor: "#28A504",
        fontWeight: "700",
        "&:hover": {
            backgroundColor: "#417557",
        },
    },
    imageHolder: {
        backgroundColor: "#e3e3e3",
        width: "50%",
        height: "144px",
        margin: "0 auto -77px auto",
        position: "relative",
        zIndex: "99",
    },
}));

const ProductLoader = ({ lang }) => {
    const classes = useStyles();
    return (
        <div className="product">

            <Box style={{ margin: '0px auto -80px auto', width: '120px', height: '120px', zIndex: '9999', position: 'relative' }} >
                <Skeleton animation="wave" variant="circle" width="100%" height="100%" />
            </Box>
            <div className="content">
                <p>
                    <Skeleton animation="wave" height="33px" width="87%" style={{ margin: "0 auto" }} />
                </p>
                <p>
                    <Skeleton animation="wave" height="33px" width="87%" style={{ margin: "0 auto" }} />
                </p>
                <Hidden only={['xs']}>
                    <p>
                        <Skeleton style={{ margin: "0 auto" }} height="33px" width="30%" animation="wave" />
                    </p>
                </Hidden>
                <div className="productBoxBottomArea">
                    <div className="IconArea">
                        <BookmarkIcon style={{ fill: "#e3e3e3" }} />
                    </div>
                    <div className="btnArea">
                        <Button
                            variant="contained"
                            disabled={true}
                            color="primary"
                            className={classes.btn + " sbBtn"}
                        >
                            {lang === "ar" ? "تفاصيل المنتج" : "جزئیات محصول"}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductLoader;
